"use strict";
export const weekdays = ["Monday", "Tuesday", "Wednesday", "Thursday", "Friday", "Saturday", "Sunday"];
export const months = [
  "January",
  "February",
  "March",
  "April",
  "May",
  "June",
  "July",
  "August",
  "September",
  "October",
  "November",
  "December"
];
export const getMonth = (year, month) => {
  const monthIndex = month - 1;
  const firstWeekday = new Date(year, monthIndex, 1).toLocaleDateString("en", {
    weekday: "long"
  });
  const numberOfDays = new Date(year, monthIndex + 1, 0).getDate();
  return {
    name: months[monthIndex],
    firstWeekday,
    numberOfDays
  };
};
export const getCalendarDate = (date) => ({
  year: date.getFullYear(),
  month: date.getMonth() + 1,
  day: date.getDate()
});
const compareCalendarDate = (a, b) => compareNumber(a.year, b.year) || compareNumber(a.month, b.month) || compareNumber(a.day, b.day);
const compareNumber = (a, b) => a - b;
export const CalendarDates = {
  eq: (a, b) => compareCalendarDate(a, b) === 0,
  lt: (a, b) => compareCalendarDate(a, b) < 0,
  lte: (a, b) => compareCalendarDate(a, b) <= 0,
  gt: (a, b) => compareCalendarDate(a, b) > 0,
  gte: (a, b) => compareCalendarDate(a, b) >= 0
};
